import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="dropdown"
export default class extends Controller {
  static targets = ["menu"];

  connect() {
    this.menuTarget.classList.add("hidden");
    this.boundOutsideClick = this.outsideClickListener.bind(this);
  }

  toggleMenu(event) {
    event.stopPropagation();
    this.menuTarget.classList.toggle("hidden");

    if (!this.menuTarget.classList.contains("hidden")) {
      document.addEventListener("click", this.boundOutsideClick);
    } else {
      document.removeEventListener("click", this.boundOutsideClick);
    }
  }

  outsideClickListener(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.add("hidden");
      document.removeEventListener("click", this.boundOutsideClick);
    }
  }
}
